import EmphasisHeading from '@pc/components/Works/Panel/shared/Heading/EmphasisHeading'
import EmphasisSelectBox from '@pc/components/Works/Panel/shared/Selectbox/EmphasisSelectBox'
import type { SearchParamsAttributes, Wages } from '@pc/components/Works/Panel/types'
import { buildDynamicSearchApiUrl } from '@pc/components/Works/Panel/utils/workSearchApi'
import BaseSelectPanel from './BaseSelectPanel'

interface PropsType {
  params: SearchParamsAttributes
}

const WageSelectPanel = (props: PropsType) => {
  const { params } = props

  const el = document.querySelector<HTMLElement>('.js-works-search-panel')
  const wagesAttr = el?.dataset.worksWages
  const wages: Wages[] = wagesAttr !== undefined ? JSON.parse(wagesAttr).data : []

  const handleChange = (e: { target: HTMLSelectElement }) => {
    const value = e.target.value

    // 「希望なし」が選択された場合は検索条件から外す必要があるため。
    const salaryAmount = value !== '' ? value : null

    const mergedParams = { ...params, salary_amount: salaryAmount }
    const endPoint = buildDynamicSearchApiUrl(mergedParams)

    window.location.href = endPoint
  }

  const wageOptions = wages.map((wage: Wages) => {
    return (
      <option key={wage.id} value={wage.attributes.legacy_url_value}>
        {wage.attributes.name}
      </option>
    )
  })

  return (
    <BaseSelectPanel>
      <EmphasisHeading>時給</EmphasisHeading>
      <div className="mt-2.5">
        <EmphasisSelectBox className="w-full pr-11" value={params.salary_amount} onChange={handleChange} ariaLabel="時給を選択">
          <option value="">希望なし</option>
          {wageOptions}
        </EmphasisSelectBox>
      </div>
    </BaseSelectPanel>
  )
}

export default WageSelectPanel
